import React, { forwardRef } from "react";
import MUIIconButton from "@mui/material/IconButton";
import { Tooltip } from "../../index";
const IconButton = forwardRef(({ tooltipTitle, children, ...props }, ref) => {
    return tooltipTitle && !props.disabled ? (React.createElement(Tooltip, { title: tooltipTitle },
        React.createElement(MUIIconButton, { ...props, ref: ref }, children))) : (React.createElement(MUIIconButton, { ref: ref, ...props }, children));
});
IconButton.displayName = "IconButton";
export default IconButton;
//# sourceMappingURL=IconButton.js.map